/** 加盟店包括ユーザメニュー */
export const NAV_MENU_MERCHANT_INC = [
  {
    id: 1,
    text: "申請状況管理",
    permissions: [
      {
        id: "progress",
        items: [
          {
            type: "link",
            text: "申請状況照会",
            href: "/application-status",
          },
        ],
      },
      {
        id: "individual_counseling",
        items: [
          {
            type: "link",
            text: "個別取扱確認結果一覧",
            href: "/individual-handling-confirmation",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    text: "加盟店管理",
    permissions: [
      {
        id: "apply_company_read",
        items: [
          { type: "link", text: "加盟店一覧", href: "/merchants" },
          { type: "link", text: "入金口座一覧", href: "/bank-accounts" },
        ],
      },
      {
        id: "apply",
        items: [
          {
            type: "link",
            text: "加盟店情報申請（包括）",
            href: "/merchant/inclusion-application",
          },
        ],
      },
      {
        id: "rate_setting",
        items: [
          {
            type: "link",
            text: "料率調整案件一覧",
            href: "/rate-adjustment-case-list",
          },
        ],
      },
      {
        id: "individual_counseling",
        items: [
          {
            type: "link",
            text: "個別相談案件一覧",
            href: "/individual-counseling-project",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    text: "アカウント管理",
    permissions: [
      {
        id: "account",
        items: [{ type: "link", text: "ユーザ管理", href: "/users" }],
      },
    ],
  },

  // SSO連携用
  {
    id: 4,
    text: "サービス運用・精算",
    permissions: [
      {
        id: "neo_connection_info",
        items: [
          {
            type: "link",
            text: "接続情報管理",
            href: "/sso?mnId=0000000042",
          },
        ],
      },
      {
        id: "neo_sales",
        items: [
          {
            type: "link",
            text: "売上管理",
            href: "/sso?mnId=0000000050",
          },
        ],
      },
      {
        id: "neo_file_download",
        items: [
          {
            type: "link",
            text: "ダウンロードファイル予約",
            href: "/sso?mnId=0000000046",
          },
          {
            type: "link",
            text: "ダウンロードファイル管理",
            href: "/sso?mnId=0000000048",
          },
        ],
      },
      {
        id: "neo_reimbursement",
        items: [
          {
            type: "link",
            text: "精算管理",
            href: "/sso?mnId=0000000044",
          },
        ],
      },
      {
        id: "neo_response_setting",
        items: [
          {
            type: "link",
            text: "その他機能",
            href: "/sso?mnId=0000000053",
          },
        ],
      },
    ],
  },
  {
    id: 5,
    text: "コミュニケーション等",
    permissions: [
      {
        id: "neo_no_restriction",
        items: [
          {
            type: "link",
            text: "ドキュメント一覧",
            href: "/sso?mnId=0000000010",
          },
          {
            type: "link",
            text: "お問い合わせ一覧",
            href: "/sso?mnId=0000000011",
          },
          {
            type: "link",
            text: "お知らせ一覧",
            href: "/sso?mnId=0000000012",
          },
        ],
      },
    ],
  },
];
